const CURRENT_STORAGE_VERSION = '2'

interface LocalStorageDefaults {
  itemsPerPage: string
  pageNumber: string
}

const DEFAULT_VALUES: LocalStorageDefaults = {
  itemsPerPage: '20',
  pageNumber: '1',
}

/**
 * Initializes localStorage versioning system.
 * Clears localStorage if version has changed and sets default values.
 * This ensures users get the most recent localStorage structure when they log in.
 */
export const initializeLocalStorageVersioning = (): void => {
  try {
    const storedVersion = localStorage.getItem('storageVersion')

    if (storedVersion !== CURRENT_STORAGE_VERSION) {
      localStorage.clear()

      localStorage.setItem('storageVersion', CURRENT_STORAGE_VERSION)

      Object.entries(DEFAULT_VALUES).forEach(([key, value]) => {
        localStorage.setItem(key, value)
      })

      console.log(`LocalStorage updated to version ${CURRENT_STORAGE_VERSION}`)
    } else {
      Object.entries(DEFAULT_VALUES).forEach(([key, value]) => {
        if (!localStorage.getItem(key)) {
          localStorage.setItem(key, value)
        }
      })
    }
  } catch (error) {
    console.warn('Failed to initialize localStorage versioning:', error)
  }
}
